import {LayerName, LayerVisibilityState, RoofActiveStatus} from "../@types/store";
import {useViewerStore} from "../store/store";

export const toggleLayer = (layer: LayerName, value?: boolean): void => {
    const { layerVisibilityState } = useViewerStore.getState();

    const nextValue =
        typeof value === 'boolean' ? value : !layerVisibilityState[layer];

    useViewerStore.setState({
        layerVisibilityState: {
            ...layerVisibilityState,
            [layer]: nextValue,
        },
    });
};

export const resetLayers = (): void => {
    useViewerStore.setState({
        layerVisibilityState: {
            roof: true,
            obstruction: true,
            tree: true,
            setback: true,
            pathway: true,
            modules: true,
            irradiance: true,
            maps: true,
            terrain: true,
        } satisfies LayerVisibilityState,
    });
};

export function setPathname(pathName: string): void {
    useViewerStore.setState({pathname : pathName});
}


export const updateActiveStatusOfRoof = (
    roofId: number | string,
    status: boolean,
): void => {
    const { activeStatuses } = useViewerStore.getState();

    const updatedStatuses: RoofActiveStatus[] = activeStatuses.map((entry) =>
        Number(entry.roofId) === Number(roofId)
            ? { ...entry, isSelected: status }
            : entry,
    );

    useViewerStore.setState({
        activeStatuses: updatedStatuses,
        isRoofActiveStatusUpdating: false,
    });
};

export const resetToDefaults  = () : void => {
    useViewerStore.setState({
        roofIrradiance: 0,
        utilityWattage: 0,
        roofAreaSize: 0,
        totalSystemSize: 0,
        modeCircleSolar: 0,
        actualWattage: 0,
        modeCount: 0,
        buildingWise33PercentRuleModuleCountList: [],
        efficiency: 0,
        modeChartSolar: Array(12).fill(0),
        modeChartIrr: Array(12).fill(0),
        roofInfoArr: [],
        multiplier: 0,
        savedAnnualIdealMultiplier: 0,
        savedRoofModulesLayout: [],
        defaultLayoutModulesAtInitialLoad: [],
        savedLocationCoordinates: {
            latitude: 0,
            longitude: 0,
        },
        savedRoofFaceIdArray: [],
        savedRoofEdgeTypeCount: {
            ridge: 0,
            valley: 0,
            eave: 0,
            rake: 0,
            other: 0,
        },
        savedRoofWiseIdealMultiplier: [],
        savedRoofWiseAccessMultiplierDataArray: [],
        savedAccessMultipliersForSolarRoofs: [],
        epcPriceData: [],
        ppwValue: 0,
        freezePPW: false,
        initialPPWReady: false,
        epcValue: 0,
        pricingType: 'PPW',
        pricingValue: '',
        isEscalatorSelected: false,
        isRoofTagVisible: false,
        escalatorValue: undefined,
        annualUsage: null,
        epcEstimatedProduction: null,
        epcMessage: '',
        epcCalculatedPrice: '- Quote Not Run -',
        totalSunnovaEPCWithTrees: '- Quote Not Run -',
        solarRateSettings: undefined,
        moduleMultiplierAverage: 0,
        pathname: '/configure/roof',
        isBgCalc: false,
        layerVisibilityState: {
            roof: true,
            obstruction: true,
            tree: true,
            setback: true,
            pathway: true,
            modules: true,
            irradiance: true,
            maps: true,
            terrain: true,
        },
        isBuildingChange: false,
        isBoxSelectMode: false,
        isPushPullMode: false,
        rayIntersectArr: [],
        isLargeDesignShadeGatingActive: false,
        shadeEnabledRoofFaceIds: [],
        isRoofSquareInitialDataLoaded: false,
        isRoofSquareDataUnavailable: false,
        isRoofSquarePriceUpdating: false,
        isNonFinalizedSavedDesign: false,
        roofSquareErrorMessage: 'Floor',
        roofSquareTableData: [],
        activeStatuses: [],
        roofSquareDataFromPanda: [],
        roofSquareRetries: 0,
        hasTreeMoved: false,
        refreshQuestionableRoof: false,
        refreshingShade: false,
        showInactiveRoofs: false,
        detachedStructureBuildingIds: [],
    });
}

export const addSelectedTree = (tree: any): void => {
    const { selectedTrees } = useViewerStore.getState();
    if (selectedTrees.some((t: any) => String(t.obstId) === String(tree.obstId))) return;
    useViewerStore.setState({
        selectedTrees: [...selectedTrees, tree],
    });
};


export const removeSelectedTree = (tree: any): void => {
    const { selectedTrees } = useViewerStore.getState();
    useViewerStore.setState({
        selectedTrees: selectedTrees.filter((t : any) => t.obstId !== tree.obstId),
    });
};


export const toggleSelectedTree = (tree: any): void => {
    const { selectedTrees } = useViewerStore.getState();
    const idx = selectedTrees.findIndex((t : any) => t.obstId === tree.obstId);

    useViewerStore.setState({
        selectedTrees:
            idx !== -1
                ? [...selectedTrees.slice(0, idx), ...selectedTrees.slice(idx + 1)]
                : [...selectedTrees, tree],
    });
};

export const registerRef =
    (key: string) =>
        (node: HTMLElement | null) => {
            if (!node) return;

            useViewerStore.setState((state) => {
                const prev = state.refs[key];

                if (prev === node) return state;

                return { refs: { ...state.refs, [key]: node } };
            });
        };

export const removeRef = (key: string) => {
    useViewerStore.setState((state) => {
        const { [key]: _, ...rest } = state.refs;
        return { refs: rest };
    });
};

export const clickButtonWithRef = (key: string): void => {
    useViewerStore.getState().refs[key]?.click()
}

export const isDesignOriginalSite = (): boolean => {
    const selectedDesignIndex = useViewerStore.getState().selectedDesignIndex;
    return selectedDesignIndex === -1
}